import { CollapseType } from '@meitu/saas-editor-ui/es/types';

/**
 * 检查是否需二次确认
 *
 * @param currentType - 当前折叠面板类型
 */
export const checkNeedConfirm = (currentType: CollapseType | null) => {
    // 检查当前是否在图片翻译面板
    const isInImageTrans = currentType === CollapseType.MORE_MENU && !!document.querySelector('.imageTrans-panel');

    return isInImageTrans;
};
